export const USER_NAV = [
  { to: "/dashboard", label: "Dashboard", icon: "dashboard", testId: "nav-user-dashboard" },
  { to: "/terminal", label: "Terminal", icon: "markets", testId: "nav-user-terminal" },
  { to: "/demo-account", label: "Abrir conta demo", icon: "demo", testId: "nav-user-demo-account" },
];
